import React from 'react';
import { Row, Col, Label , Collapse, Button } from "reactstrap";
import { formatNullableValue } from '../../../../utils/formatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {IconeSetaDescer, IconeSetaDireita, IconeSetaSubir} from "../../../comum/components/Icones";

export default class ImportacaoCard extends React.Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    };

    handleDetalhesClick = () => {
        this.controller.abrirDetalhes(this.props.data);
    };

    render() {
        return (
            <Col xs={12} md={6} lg={4} onClick={ this.handleClick }>
                <div className="card-navio">
                    <Row>

                        <Col xs={12} className="px-0">
                            <div className="titulo">
                                <Label className="titulo-principal">{ this.props.data[this.props.titulo] }</Label>
                                <Label className="subtitulo">{ this.props.data[this.props.subtitulo] }</Label>
                            </div>
                        </Col>

                        {this.props.colunas.map((col, x) =>
                            (col.dataField !== this.props.titulo) &&
                            (col.dataField !== this.props.subtitulo) &&
                            (col.dataField !== "StatusProcesso") &&
                            (col.dataField !== "detalhes") &&
                            <Col xs={6} className="px-0" key={x}>
                                <div className="info bg-cinza">
                                    <div className="titulo">{col.text}</div>
                                    <div className="valor">{col.formatter ?
                                        (
                                            col.formatExtraData ?
                                                formatNullableValue(col.formatter(col.dataField.split('.').reduce((o, i) => o[i], this.props.data), col, null, col.formatExtraData))
                                                :
                                                formatNullableValue(col.formatter(col.dataField.split('.').reduce((o, i) => o[i], this.props.data)))
                                        )
                                        :
                                        formatNullableValue(col.dataField.split('.').reduce((o, i) => o[i], this.props.data))
                                    }</div>
                                </div>
                            </Col>
                        )}

                        { this.props.data.StatusProcesso
                            && <Col xs={12} className="px-0">
                                <div className="info">
                                    <div className={`situacao-btn ${ this.props.data.StatusProcesso.toLowerCase() }`}>{ this.props.data.StatusProcesso }</div>
                                </div>
                            </Col>
                        }

                        <Col xs={12}>
                            <div className="area-colapsada">
                                <Button className="btn" onClick={this.handleDetalhesClick} >
                                    Detalhes
                                    <span><IconeSetaDireita /></span>
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/components/ImportacaoCard.js